// Youssef Selkani
// 2019

import React, { Component } from 'react'
import {
  Image,
  Button,
  Grid,
  Container,
  Radio,
  Segment,
  Dropdown,
  Label,
  Loader,
  Checkbox,
  Placeholder,
  Dimmer,
  Input,
  Icon
} from 'semantic-ui-react'
import '../App.css'
import DragSortableList from 'react-drag-sortable'
import fire, { storage } from '../config/Fire'
import ScrollArea from '@xico2k/react-scroll-area'
var FontAwesome = require('react-fontawesome')

export default class Navigation extends Component {
  constructor (props) {
    super(props)
    this.state = {
      screens: [],
      orders: [],
      icons: [],
      sortedList: null,
      loading: true,
      startingScreen: null,
      position: ''
    }
  }

  componentDidMount () {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        let raw = user.email
        let userUnderscore = raw.replace(/\./g, '_')
        this.setState({ loggedIn: true, userUnderscore: userUnderscore }, () => {
          this.userData()
        })
      } else {
        this.props.history.push('/')
      }
    })
  }

  fetchLogo = () => {
    storage
      .ref(`/icons/${this.state.userUnderscore}`)
      .child('appicon')
      .getDownloadURL()
      .then((icon) => {
        this.setState({ icon })
      })
  }

  selectDrawer = () =>
    this.setState({
      drawer: true,
      navbar: false,
      position: 'left'
    })

  selectNavbar = () =>
    this.setState({
      navbar: true,
      drawer: false,
      position: 'top'
    })

  startingScreen = (e, { value }) => {
    this.setState({ startingScreen: value })
  }

  resetstartingScreen = () => {
    this.setState({ startingScreen: null })
  }
  onSort = (sortedList) => {
    this.setState({ sortedList: sortedList, list: sortedList })
  }

  ld = () => {
    this.setState({ position: 'left' })
  }
  rd = () => {
    this.setState({ position: 'right' })
  }
  tb = () => {
    this.setState({ position: 'top' })
  }
  bb = () => {
    this.setState({ position: 'bottom' })
  }

  userData = (e) => {
    fetch('https://murkstomstag.herokuapp.com/api/v1/user/data', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((obj) => {
        if ((obj.code = 200)) {
          this.setState({
            appname: obj.appname,
            description: obj.description,
            accent: obj.accent
          })
          this.navigationInfo()
          this.viewScreens()
          this.fetchLogo()
          this.fetchIcons()
        } else {
          this.setState({
            loading: false,
            error: 'Internal Server Error | code 500'
          })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  saveData = (e) => {
    let { sortedList, navbar, drawer, startingScreen, list, position } = this.state
    if (!drawer && !navbar) {
      this.setState({ error: 'Please select a menu layout.' })
    } else {
      e.preventDefault()
      this.setState({ loading: true, error: null })
      fetch('https://murkstomstag.herokuapp.com/api/v1/app/navigation', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userUnderscore: this.state.userUnderscore,
          menuOrder: sortedList,
          startingScreen: startingScreen,
          drawer: drawer,
          navbar: navbar,
          list: list,
          position: position
        })
      })
        .then((response) => {
          if (response.status === 200) {
            this.navigationInfo()
            this.fetchIcons()
            this.viewScreens()
            this.setState({ saved: true, saving: false })
          } else {
            this.setState({
              error: 'Something went wrong' + ' | Error code: ' + response.status,
              loading: false
            })
          }
        })
        .catch((error) => {
          console.log(error)
          this.setState({ error: error.message, loading: false })
        })
    }
  }

  navigationInfo = (e) => {
    let { userUnderscore } = this.state
    this.setState({ loading: true })
    fetch('https://murkstomstag.herokuapp.com/api/v1/view/navigation', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if (json.code === 200) {
          if (json.menuOrder === null) {
            this.setState({
              drawer: json.drawer,
              navbar: json.navbar,
              position: json.position,
              startingScreen: json.startingScreen
            })
          } else {
            this.setState({
              drawer: json.drawer,
              navbar: json.navbar,
              position: json.position,
              startingScreen: json.startingScreen
            })
          }
        } else if (json.code === 404) {
          console.log('code 404')
        }
      })
  }

  viewScreens = (e) => {
    let { userUnderscore } = this.state
    this.setState({ loading: true })
    fetch('https://murkstomstag.herokuapp.com/api/v1/view/screens', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if (json.code === 200) {
          if (json.empty === true) {
            this.setState({ loading: false, empty: true })
          } else {
            var orders = []
            var list = []
            let raw = json.screens.sort((a, b) => (a.rank > b.rank ? 1 : b.rank > a.rank ? -1 : 0))
            for (let x in raw) {
              orders.push({
                value: raw[x].id,
                text: raw[x].name,
                key: raw[x].name
              })
            }
            for (let x in raw) {
              list.push({
                content: raw[x].name,
                key: raw[x].id
              })
            }

            this.setState({
              screens: raw,
              orders: orders,
              list: list,
              loading: false
            })
          }
        } else {
          this.setState({ error: 'Internal Server Error | code 500', loading: false })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message
        })
      })
  }

  fetchIcons = (e) => {
    let { userUnderscore } = this.state
    fetch('https://murkstomstag.herokuapp.com/api/v1/view/screens', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if (json.code === 200) {
          let sorted = json.screens.sort((a, b) => (a.rank > b.rank ? 1 : b.rank > a.rank ? -1 : 0))
          this.setState({
            icons: sorted,
            iconLoading: false
          })
        } else {
          this.setState({ empty: true })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message
        })
      })
  }

  pickIcon = (item) => {
    this.setState({
      iconLoading: true,
      selectedIcon: item.id
    })
    let { userUnderscore, iconname } = this.state
    fetch('https://murkstomstag.herokuapp.com/api/v1/save/icon', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: userUnderscore,
        selectedIcon: iconname,
        screenID: item.id
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if (json.code === 200) {
          this.fetchIcons()
        }
      })
      .catch((error) => {
        this.setState({
          iconLoading: false,
          error: error.message
        })
      })
  }

  handleIconSelect = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  render () {
    let {
      loading,
      appname,
      icon,
      description,
      saved,
      accent,
      drawer,
      navbar,
      startingScreen,
      orders,
      list,
      error,
      empty,
      position,
      iconLoading,
      selectedIcon
    } = this.state

    const screens = this.state.screens.map((item, index) => (
      <div
        style={{
          backgroundColor: accent,
          color: '#fff',
          marginBottom: 14,
          padding: 14,
          height: 50,
          justifyContent: 'center'
        }}
        key={index}>
        <h3 style={{ marginLeft: 7 }}>
          <FontAwesome name={item.icon} color='black' style={{ marginRight: 12 }} />
          {item.content || item.name}
        </h3>
      </div>
    ))
    
    const columns = this.state.screens.map((item, index) => (
      <Grid.Column textAlign='center' key={index}>
      <FontAwesome name={item.icon} color='black' />
      </Grid.Column>
    ))

    const menuIcons = this.state.icons.map((item, index) => (
      <Grid.Row key={index}>
        <Grid.Column width='6'>
          <h4>
            <FontAwesome name={item.icon} color='black' style={{ marginRight: 12 }} />
            {item.name}
          </h4>
        </Grid.Column>
        <Grid.Column width='10'>
          <Segment basic fluid>
            <Input
              size='mini'
              label='Name'
              color='black'
              fluid
              placeholder='placeholder'
              type='text'
              action={
                <Button
                  size='mini'
                  icon
                  onClick={() => this.pickIcon(item)}
                  icon='save'
                  color='black'
                  loading={iconLoading && item.id === selectedIcon}
                  disabled={iconLoading && item.id === selectedIcon}
                />
              }
              onChange={this.handleIconSelect}
              name='iconname'
            />
          </Segment>
        </Grid.Column>
      </Grid.Row>
    ))

    return (
      <Container className='masterdiv'>
        <div className='mb center'>
          <h2>Navigation</h2>
          <Button
            disabled={loading}
            onClick={this.saveData}
            content={!saved ? 'Save' : 'Saved successfully. Click to refresh!'}
            color={!saved ? 'black' : 'green'}
          />
          <div style={{ color: '#F55E64' }} className='mt'>
            <h4>{error}</h4>
          </div>
        </div>
        {loading && (
          <Dimmer active page blurring='default'>
            <Loader active>Loading...</Loader>
          </Dimmer>
        )}
        {!empty && (
          <Grid centered stackable verticalAlign='top' fluid centered>
            <Grid.Column width='6'>
              <Label size='medium'>Menu Icons</Label>
              <Segment>
                <h4>
                  To find icon names please click{' '}
                  <a
                    rel='noopener noreferrer'
                    href='https://zurb.com/playground/foundation-icon-fonts-3'
                    target='_blank'>
                    here
                  </a>
                </h4>
                <Grid stackable compact verticalAlign='middle' fluid centered>
                  {menuIcons}
                </Grid>
              </Segment>

              <Label size='medium'>Menu Order</Label>
              <Segment>
                <p>Drag & Drop items on the list below</p>
                <DragSortableList
                  items={list}
                  onSort={this.onSort}
                  dropBackTransitionDuration={0.25}
                  type='vertical'
                />
              </Segment>
            </Grid.Column>

            <Grid.Column width='4'>
              <Label size='medium'>Menu Layout</Label>
              <Segment padded textAlign='center'>
                <h4 className='center'>Drawer Menu</h4>
                <Radio toggle onChange={this.selectDrawer} checked={drawer} disabled={drawer} />
                {drawer && (
                  <div className='mts'>
                    <Label size='medium'>Position</Label>
                    <div className='mtbs'>
                      <Checkbox onChange={this.ld} checked={position === 'left'} label='Left' />
                    </div>

                    <Checkbox onChange={this.rd} checked={position === 'right'} label='Right' />
                  </div>
                )}
              </Segment>
              <Segment padded textAlign='center'>
                <h4 className='center'>NavBar Menu</h4>
                <Radio toggle onChange={this.selectNavbar} checked={navbar} disabled={navbar} />
                {navbar && (
                  <div className='mts'>
                    <Label size='medium'>Position</Label>
                    <div className='mtbs'>
                      <Checkbox onChange={this.tb} checked={position === 'top'} label='Top' />
                    </div>
                    <Checkbox onChange={this.bb} checked={position === 'bottom'} label='Bottom' />
                  </div>
                )}
              </Segment>

              <Label size='medium'>Starting Screen</Label>
              <Segment>
                {!startingScreen ? (
                  <Dropdown
                    text='Select a screen'
                    upward
                    value={startingScreen}
                    onChange={this.startingScreen}
                    options={orders}
                  />
                ) : (
                  <p>Screen ID: {startingScreen}</p>
                )}
                {startingScreen && (
                  <div className='mts'>
                    <Label size='small' color='black' ribbon>
                      Successfully configured
                    </Label>
                    <div className='mts'>
                      <Button basic compact size='small' onClick={this.resetstartingScreen}>
                        Reset
                      </Button>
                    </div>
                  </div>
                )}
              </Segment>
            </Grid.Column>

            <Grid.Column width='5'>
              <div className='mb center'>
                <Label size='medium'>
                  {drawer && 'Drawer Menu'} {navbar && 'Navigation Bar'} Preview
                </Label>
              </div>
              <div className='newframe'>
                <div className='newframe-content' style={{ backgroundColor: '#fff' }}>
                  <div className='newframe-content-body'>
                    <ScrollArea trackHidden height='620px'>
                      <div
                        style={{
                          marginLeft: position === 'right' ? 50 : 0,
                          marginRight: position === 'left' ? 50 : 0
                        }}>
                        {drawer && (
                          <div className='lightshadow'>
                            <div
                              style={{
                                backgroundColor: '#fff',
                                paddingBottom: 28,
                                paddingTop: 28,
                                height: '100%'
                              }}>
                              {icon ? (
                                <Image
                                  centered
                                  src={icon}
                                  style={{ height: 50, resizeMode: 'contain' }}
                                />
                              ) : (
                                <center>
                                  <Placeholder fluid style={{ height: 50, width: 50 }}>
                                    <Placeholder.Image />
                                  </Placeholder>
                                </center>
                              )}
                              <div className='center mts'>
                                <h2>{appname}</h2>
                                <p>{description}</p>
                              </div>
                            </div>
                            <div style={{ backgroundColor: '#fff' }}>{screens}</div>
                          </div>
                        )}
                        {navbar && (
                          <div
                            style={{
                              display: 'flex',
                              height: '620px',
                              backgroundColor: '#f6f6f6',
                              alignItems: position === 'bottom' ? 'flex-end' : 'flex-start'
                            }}>
                            <Grid
                              centered
                              celled
                              columns='equal'
                              fluid
                              style={{ margin: 0, padding: 0, backgroundColor: '#fff' }}>
                              {columns}
                            </Grid>
                          </div>
                        )}
                      </div>
                    </ScrollArea>
                  </div>
                </div>
              </div>
            </Grid.Column>
          </Grid>
        )}

        {empty ? (
          <Segment placeholder fluid textAlign='center' style={{ backgroundColor: '#fcfcfc' }}>
            <h3>Nothing to display here!</h3>
            <a href='/maker'>Add some screens first</a>
          </Segment>
        ) : (
          <div className='mt center'>
            <h4>
              <Icon name='exclamation triangle' color='yellow' />
              To change theme colors please visit <a href='/app/style'>this</a> page.
            </h4>
          </div>
        )}
      </Container>
    )
  }
}
